@if (!errorSettingStatus) {
	<div class="pop-up-dialog-v2">
		<div class="header-container">
			<h3 i18n="@@endBillingDialog-endBillingDialogHeader">End Billing</h3>
			@if (confirmDisabled) {
				<mat-spinner diameter="25" class="loading-spinner"></mat-spinner>
			}
		</div>
		<mat-divider></mat-divider>
		<mat-dialog-content>
			<div>
				<ng-container i18n="@@endBillingDialog-areYouCertain2"
					>Are you certain you wish to end billing for</ng-container
				>
				{{ data.companyName }}?
			</div>
		</mat-dialog-content>
		<mat-dialog-actions>
			<button
				(click)="onCloseClicked()"
				class="secondary-small-button"
				i18n="@@endBillingDialog-endBillingDialogCancel"
				data-automation-id="end-billing-dialog-cancel-button"
			>
				Cancel
			</button>
			<button
				(click)="onConfirmClicked()"
				i18n="@@endBillingDialog-endBillingDialogConfirm"
				i18n="@@billingContract-continueButton"
				class="primary-small-button"
				data-automation-id="end-billing-dialog-confirm-button"
			>
				Confirm
			</button>
		</mat-dialog-actions>
	</div>
}

@if (errorSettingStatus) {
	<div class="pop-up-dialog-v2">
		<h3 i18n="@@endBillingDialog-errorSettingStatusHeader">Error!</h3>
		<mat-divider></mat-divider>
		<mat-dialog-content>
			<div>
				<ng-container i18n="@@endBillingDialog-couldNotEnd2">Could not end billing at this time for</ng-container>
				{{ data.companyName }}. <ng-container i18n="@@endBillingDialog-tryAgain">Please try again.</ng-container>
			</div>
		</mat-dialog-content>
		<mat-dialog-actions>
			<button
				(click)="onCloseClicked()"
				class="primary-small-button"
				i18n="@@endBillingDialog-errorSettingStatusConfirm"
				data-automation-id="end-billing-dialog-ok-button"
			>
				Ok
			</button>
		</mat-dialog-actions>
	</div>
}
